import { UserGenderEnum } from '../../../../enums/user.enums';

export const selectOptions = [
  { label: 'weiblich', value: UserGenderEnum.FEMALE },
  { label: 'männlich', value: UserGenderEnum.MALE },
  { label: 'divers', value: UserGenderEnum.DIVERS },
];

export const messages = {
  default: 'Erstelle dein Benutzerkonto ganz einfach, indem du das Formular ausfüllst.',
  pending: 'Deine Registrierung wird gerade verarbeitet. Bitte habe einen Moment Geduld.',
  error:
    'Die Registrierung ist leider fehlgeschlagen. Bitte versuche es erneut oder kontaktiere den Support, falls das Problem weiterhin besteht.',
  success:
    'Vielen Dank für deine Registrierung! Wir haben dir eine E-Mail mit einem Bestätigungslink geschickt. Bitte überprüfe dein Postfach und klicke auf den Link, um deinen Account zu aktivieren.',
};
